import { Button, Modal } from 'antd';

const TaskVideo = (props: { videoUrl: string; openVideoModal: boolean; onOpen: any; onClose: any }) => {
    return (
        <div className="content-card">
            <div className="card-title">Video</div>
            {props.videoUrl ? (
                <div className="task-video" onClick={props.onOpen}>
                    <video className="video_box" src={props.videoUrl}></video>
                </div>
            ) : (
                <div className="task-video">No video</div>
            )}
            <Modal width={560} maskClosable={false} centered={true} open={props.openVideoModal} closeIcon={<></>}>
                <div>
                    <video className="video_box" controls autoPlay src={props.videoUrl}></video>
                </div>
                <div className="flex-center" style={{ marginTop: 10, columnGap: 20 }}>
                    <Button className="submit-btn" type="primary" onClick={props.onClose}>
                        Close
                    </Button>
                </div>
            </Modal>
        </div>
    );
};
export default TaskVideo;
